// ** Initial State
const initialState = {
  exam: {}, // for contest exam
  contest: {}, // for contest data
};

const contests = (state = initialState, action) => {
  switch (action.type) {
    case "EMPTY_REDUCER":
      return initialState;
    case "ADD_CONTEST_QUESTION":
      let stateCopy = { ...state };
      let examCopy = { ...stateCopy.exam };
      stateCopy.exam = { ...examCopy, ...action.data };
      return stateCopy;
    case "ADD_CONTEST_DATA":
      return { ...state, contest: action.data };
    case "APPEND_CONTEST_DATA":
      return { ...state, contest: { ...state.contest, ...action.data } };
    case "ADD_CONTEST_EXAM":
      return { ...state };
    default:
      return { ...state };
  }
};
export default contests;
